import { Pipe, PipeTransform } from '@angular/core';
import flatpickr from 'flatpickr';
import { DocumentElementResponse } from 'src/openapi-client';
import { DatepickerDirective } from '../../common/directives/datepicker.directive';
import { LOG } from '../../common/util/log';
import { ChartTimeframe, ChartTimeframes } from './chart-timeframe-selector';

@Pipe({
  name: 'dataToTimeframes',
  standalone: true,
})
export class DataToTimeframePipe implements PipeTransform {
  transform(value?: DocumentElementResponse): ChartTimeframes | undefined {
    if (!value || !value.renderable.type.includes('TABLE')) {
      return undefined;
    }

    const timeframes: ChartTimeframes = {} as ChartTimeframes;

    for (const row of value.renderable.rows) {
      if (row.cells[0].content === null || row.cells[1].content === null || row.cells[2].content === null) {
        continue;
      }

      try {
        const key: string = row.cells[0].content;

        const fromStr: string = row.cells[1].content;
        const toStr: string = row.cells[2].content;

        const from: number = flatpickr.parseDate(row.cells[1].content, DatepickerDirective.DATA_FORMAT).getTime();
        const to: number = flatpickr.parseDate(row.cells[2].content, DatepickerDirective.DATA_FORMAT).getTime();

        timeframes[key] = <ChartTimeframe>{ from, to, fromStr, toStr };
      } catch (e) {
        LOG.error(e);
      }
    }

    return timeframes;
  }
}
